// GuidelineScreen.js - ফিক্সড ভার্সন
import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Dimensions,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const {width} = Dimensions.get('window');

const GuidelineScreen = () => {
  const [searchText, setSearchText] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = [
    'All',
    'সাইন-আপ',
    'লগইন',
    'মামলা অনুসন্ধান',
    'ডায়েরী',
    // 'এসএমএস',
  ];

  const guidelines = [
    {
      id: 1,
      title: 'সাইন-আপ ও আইডি একটিভেশন',
      category: 'সাইন-আপ',
      description:
        '১. https://bdjudgecourt.com ভিজিট করুন\n২. নতুন ইউজার হলে সাইন-আপ করুন\n৩. সাইন-আপের পর ইমেইল/মোবাইল নম্বর দিয়ে পেমেন্ট করুন\n৪. সর্বশেষ দুটি নাম্বার আমাদের জানান\n৫. ৫ মিনিটের মধ্যে আইডি এক্টিভ হবে',
      date: '২৫ জানুয়ারি ২০২৬',
    },
    {
      id: 2,
      title: 'লগইন ও অটো লগআউট',
      category: 'লগইন',
      description:
        '১. সাইন-আপের ইমেইল ও পাসওয়ার্ড দিয়ে লগইন করুন\n২. প্রত্যেকবার নতুন ডিভাইসে ইমেইল ভেরিফিকেশন প্রয়োজন\n৩. সুরক্ষার জন্য অটো লগআউট হতে পারে',
      date: '২৪ জানুয়ারি ২০২৬',
    },
    {
      id: 3,
      title: 'মামলা অনুসন্ধান পদ্ধতি',
      category: 'মামলা অনুসন্ধান',
      description:
        'জি.আর ধরনের জন্য:\n• থানা সিলেক্ট করুন\n• মামলা নং:৬, মাস:১, সাল:২০১৮',
      date: '২৩ জানুয়ারি ২০২৬',
    },
    {
      id: 4,
      title: 'আমার ডায়েরী ব্যবহার',
      category: 'ডায়েরী',
      description:
        '১. "আমার ডায়েরীতে মামলা যোগ" অপশনে ক্লিক করুন\n২. মামলার তথ্য ইনপুট করুন\n৩. অ্যাকশন কলামে ক্লিক করে তারিখ আপডেট করুন',
      date: '২২ জানুয়ারি ২০২৬',
    },
    // {
    //   id: 5,
    //   title: 'অটো এসএমএস সার্ভিস',
    //   category: 'এসএমএস',
    //   description:
    //     '১. ধার্য তারিখের ২৪ ঘন্টা পূর্বে এসএমএস পাঠানো হবে\n২. বাদী ও বিবাদী উভয়কে নোটিফিকেশন যাবে',
    //   date: '২১ জানুয়ারি ২০২৬',
    // },
  ];

  const filteredGuidelines = guidelines.filter(item => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchText.toLowerCase()) ||
      item.description.toLowerCase().includes(searchText.toLowerCase());
    const matchesCategory =
      selectedCategory === 'All' || item.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.headerTitle}>নির্দেশিকা</Text>
        <Text style={styles.headerSubtitle}>
          ঢাকা কোর্ট সাইটটির নির্দেশিকা ও ব্যবহার বিধি
        </Text>
      </View>
      <View style={styles.container_body}>
        {/* Powered By */}
        {/* <View style={styles.poweredByContainer}>
          <Text style={styles.poweredByText}>
            Powered By: Siddique Enterprise
          </Text>
        </View> */}

        {/* Search Bar */}
        {/* <View style={styles.searchContainer}>
          <Icon
            name="search"
            size={22}
            color="#666"
            style={styles.searchIcon}
          />
          <TextInput
            style={styles.searchInput}
            placeholder="নির্দেশিকা অনুসন্ধান..."
            placeholderTextColor="#999"
            value={searchText}
            onChangeText={setSearchText}
          />
          {searchText !== '' && (
            <TouchableOpacity
              onPress={() => setSearchText('')}
              activeOpacity={0.7}
            >
              <Icon name="close" size={22} color="#666" />
            </TouchableOpacity>
          )}
        </View> */}

        {/* Categories */}
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.categoriesContainer}
          contentContainerStyle={styles.categoriesContent}
        >
          {categories.map(category => (
            <TouchableOpacity
              key={category}
              style={[
                styles.categoryButton,
                selectedCategory === category && styles.categoryButtonActive,
              ]}
              onPress={() => setSelectedCategory(category)}
              activeOpacity={0.7}
            >
              <Text
                style={[
                  styles.categoryText,
                  selectedCategory === category && styles.categoryTextActive,
                ]}
                numberOfLines={1}
              >
                {category}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>

        {/* Guidelines List */}
        <ScrollView
          style={styles.guidelinesList}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.guidelinesContent}
        >
          {filteredGuidelines.map(item => (
            <TouchableOpacity
              key={item.id}
              style={styles.guidelineCard}
              activeOpacity={0.8}
            >
              <View style={styles.guidelineHeader}>
                <Text style={styles.guidelineTitle} numberOfLines={2}>
                  {item.title}
                </Text>
                <View style={styles.categoryTag}>
                  <Text style={styles.categoryTagText}>{item.category}</Text>
                </View>
              </View>
              <Text style={styles.guidelineDescription}>
                {item.description}
              </Text>
              <View style={styles.guidelineFooter}>
                <Icon name="calendar-today" size={14} color="#666" />
                <Text style={styles.guidelineDate}>{item.date}</Text>
                <TouchableOpacity
                  style={styles.readMoreButton}
                  activeOpacity={0.7}
                >
                  {/* <Text style={styles.readMoreText}>বিস্তারিত</Text>
                  <Icon name="arrow-forward" size={14} color="#307ecc" /> */}
                </TouchableOpacity>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    //paddingHorizontal: 40,
  },
  container_body: {
    flex: 1,
    paddingHorizontal: 40,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 10,
    paddingTop: 10,
    paddingLeft: 40,
    //paddingBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 13,
    color: '#fff',
    opacity: 0.9,
    marginTop: 2,
  },
  poweredByContainer: {
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  poweredByText: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    margin: 12,
    paddingHorizontal: 14,
    borderRadius: 10,
    height: 48,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 3,
  },
  searchIcon: {
    marginRight: 10,
  },
  searchInput: {
    flex: 1,
    height: 48,
    fontSize: 15,
    color: '#333',
    paddingVertical: 0,
  },
  categoriesContainer: {
    maxHeight: 50,
    marginBottom: 6,
  },
  categoriesContent: {
    paddingHorizontal: 12,
    paddingVertical: 4,
  },
  categoryButton: {
    paddingHorizontal: 18,
    paddingVertical: 8,
    borderRadius: 20,
    backgroundColor: '#f0f0f0',
    marginHorizontal: 4,
    minHeight: 36,
    justifyContent: 'center',
  },
  categoryButtonActive: {
    backgroundColor: '#307ecc',
  },
  categoryText: {
    fontSize: 15,
    color: '#666',
    textAlign: 'center',
  },
  categoryTextActive: {
    color: '#fff',
  },
  guidelinesList: {
    flex: 1,
  },
  guidelinesContent: {
    paddingHorizontal: 12,
    paddingBottom: 20,
    paddingTop: 4,
  },
  guidelineCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 14,
    marginBottom: 10,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  guidelineHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  guidelineTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    flex: 1,
    marginRight: 8,
    lineHeight: 20,
  },
  categoryTag: {
    backgroundColor: '#e8f0fe',
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 12,
    minHeight: 24,
    justifyContent: 'center',
  },
  categoryTagText: {
    fontSize: 11,
    color: '#307ecc',
    fontWeight: '500',
  },
  guidelineDescription: {
    fontSize: 16,
    color: '#555',
    lineHeight: 20,
    marginBottom: 8,
  },
  guidelineFooter: {
    flexDirection: 'row',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
    paddingTop: 8,
    flexWrap: 'wrap',
  },
  guidelineDate: {
    fontSize: 12,
    color: '#666',
    marginLeft: 4,
    flex: 1,
  },
  readMoreButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  readMoreText: {
    fontSize: 13,
    color: '#307ecc',
    fontWeight: '500',
    marginRight: 2,
  },
});

export default GuidelineScreen;
